import {useEffect, useState} from "react";

function useOnShowSendForSignButton(auth, selectedCargoCaseBol, selectedCargoCaseMan) {

    const [isShowSendForSignBtn, setShowSendForSignBtn] = useState(false);

    useEffect(() => {
        let isMount = true;
        let selectedDoc;

        if (selectedCargoCaseBol !== undefined) {
            selectedDoc = selectedCargoCaseBol
        } else if (selectedCargoCaseMan !== undefined) {
            selectedDoc = selectedCargoCaseMan
        }

        if ((auth?.roles[0] === 'CAPTAIN' && auth?.user?.id === selectedDoc[0].captain?.id && selectedDoc[0]?.status === 'DRAFT')
            || (auth?.roles[0] === 'CAPTAIN' && auth?.user?.id === selectedDoc[0].captain?.id && selectedDoc[0]?.status === 'TO_CORRECT')
            || (auth?.roles[0] === 'FORWARDER' && auth?.login.toLowerCase() === selectedDoc[0]?.creator.toLowerCase() && selectedDoc[0]?.status === 'DRAFT')
            || (auth?.roles[0] === 'FORWARDER' && auth?.login.toLowerCase() === selectedDoc[0]?.creator.toLowerCase() && selectedDoc[0]?.status === 'TO_CORRECT')
            || (auth?.roles[0] === 'CAPTAIN' && auth?.user?.id === selectedDoc[0].captain?.id && selectedDoc[0]?.status === 'SIGNED_CAPTAIN')
            || (auth?.roles[0] === 'FORWARDER' && auth?.login.toLowerCase() === selectedDoc[0]?.creator.toLowerCase() && selectedDoc[0]?.status === 'SIGNED_CAPTAIN')) {
            isMount && setShowSendForSignBtn(true)
        } else {
            isMount && setShowSendForSignBtn(false)
        }

        return () => {
            isMount = false;
        }
    },[auth, selectedCargoCaseBol, selectedCargoCaseMan])

    return {isShowSendForSignBtn};
}

export default useOnShowSendForSignButton;
